export default "__VITE_ASSET__CEq1RaDe__"